<template>
  <section class="agents-cta-band">
    <div class="container">
      <div class="cta-row">
        <div>
          <h2>Inscribe hoy. Cobra cada mes.</h2>
          <p>
            Descarga la presentación completa para compartirla con tus clientes y tu equipo.
          </p>
        </div>
        <div class="cta-actions">
          <a
            class="btn btn-cta-primary"
            :href="pdfUrl"
            target="_blank"
            rel="noopener noreferrer"
          >
            Descargar presentación (PDF)
            <i class="fas fa-external-link-alt ml-2" />
          </a>
          <router-link to="/plans" class="btn btn-cta-ghost">Ver planes</router-link>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import { HMP_PRESENTATION_PDF } from '../data/hmpLinks2027'

/**
 * CTA agentes: PDF Drive + ver planes (mockup 2027).
 */
export default {
  name: 'AgentsCtaBand',
  data() {
    return {
      pdfUrl: HMP_PRESENTATION_PDF
    }
  }
}
</script>

<style lang="scss" scoped>
@import '../styles/variables';

.agents-cta-band {
  background: $landing-bg-gray;
  padding: 56px 0;
}

.cta-row {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: space-between;
  gap: 24px;
}

h2 {
  font-size: clamp(1.6rem, 3.5vw, 2.5rem);
  font-weight: 800;
  color: $landing-primary-color;
  margin: 0 0 10px;
}

p {
  margin: 0;
  color: $landing-text-medium;
  font-size: 1.05rem;
  max-width: 48ch;
}

.cta-actions {
  display: flex;
  gap: 12px;
  flex-wrap: wrap;
}

.btn-cta-primary,
.btn-cta-ghost {
  display: inline-flex;
  align-items: center;
  border-radius: 12px;
  padding: 14px 22px;
  font-weight: 700;
  text-decoration: none;
}

.btn-cta-primary {
  background: $landing-primary-color;
  color: #fff;
  border: 0;

  &:hover {
    background: $landing-primary-dark;
    color: #fff;
    text-decoration: none;
  }
}

.btn-cta-ghost {
  background: transparent;
  color: $landing-text-dark;
  border: 1.5px solid $landing-primary-color;

  &:hover {
    background: $landing-bg-white;
    color: $landing-primary-color;
    text-decoration: none;
  }
}

@media (max-width: 700px) {
  .agents-cta-band {
    padding: 40px 16px;
  }

  .cta-actions {
    width: 100%;
  }

  .btn-cta-primary,
  .btn-cta-ghost {
    width: 100%;
    justify-content: center;
  }
}
</style>
